module.exports = __webpack_public_path__ + "static/media/Group.84222843.svg";